import React from 'react';
import {
    Grid,
    Box,
    Typography,
    styled,
    useMediaQuery,
    IconButton,
} from '@mui/material';
import { useLocation, useHistory } from 'react-router-dom';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MobileDrawer from './MobileDrawer';

const GridShift = styled(Grid)(({ theme }) => ({
    background: 'linear-gradient(130deg, #4632DA, #06d9fa)',
    padding: '10px 0',
    [theme.breakpoints.down('md')]: {
        padding: '5px 0',
    },
}));

const BoxShift = styled(Box)(({ theme }) => ({
    minHeight: '43px',
    // width: '100%',
    [theme.breakpoints.up('md')]: {
        marginLeft: '2rem',
    },
    [theme.breakpoints.down('md')]: {
        textAlign: 'center',
        width: '254px',
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));

/**
 * Component for setting a title banner.
 *
 * @component Title
 * @param {object} props props
 * @param {string} props.title Title for the Banner
 * @return (
 * <Title/>
 * )
 */

const Title = props => {
    const location = useLocation();
    const history = useHistory();

    const [open, setOpen] = React.useState(false);
    const isTabletAndAbove = useMediaQuery(theme => theme.breakpoints.up('md'));
    // log result
    //console.log("The username from ToolBar.js is " + props.state.username + " with an acronym of " + props.state.ackronym + " and a user type of " + props.state.type + ".");
    const pathnameSegments = location.pathname.split('/');

    // Check if the pathname has more than two segments
    const hasMoreThanOneSegments = pathnameSegments.filter(
        item => item !== ''
    ).length;
    // console.log(
    //     hasMoreThanOneSegments,
    //     'hasMoreThanOneSegments',
    //     pathnameSegments[1],
    //     hasMoreThanOneSegments > 1
    // );
    const handleGoBack = () => {
        // Go back to the previous page in the browser history
        history.goBack();
    };

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };
    return (
        <Grid container directon="row" justifyContent="center" alignItems="top">
            <br />

            <GridShift
                sx={{
                    position:
                        !isTabletAndAbove && hasMoreThanOneSegments > 1
                            ? 'fixed'
                            : 'static',
                    zIndex:
                        !isTabletAndAbove && hasMoreThanOneSegments > 1
                            ? 40
                            : 1,
                }}
                container
                xs={12}
                directon="row"
                justifyContent="center"
                alignItems="top"
            >
                <Grid
                    item
                    xs={12}
                    sx={{
                        minHeight: '33px',
                        mx: '.3rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    {/*(!isTabletAndAbove && hasMoreThanOneSegments > 1) ||
                        (((!isTabletAndAbove &&
                            pathnameSegments[1] === 'action' &&
                            !isTabletAndAbove) ||
                            pathnameSegments[1] === 'book-teacher' ||
                            pathnameSegments[1] === 'history' ||
                            pathnameSegments[1] === 'notifications')*/}
                    {!isTabletAndAbove && (
                        <IconButton
                            aria-label="back"
                            size="medium"
                            sx={{ color: '#FFFEFE' }}
                            onClick={handleGoBack}
                        >
                            <KeyboardBackspaceIcon fontSize="inherit" />
                        </IconButton>
                    )}

                    <BoxShift>
                        <Typography
                            variant="h3"
                            sx={{ color: '#FFFEFE', verticalAlign: 'middle' }}
                        >
                            {props.title}
                        </Typography>
                    </BoxShift>
                    {!isTabletAndAbove &&
                        location.pathname.includes('/profile') && (
                            <IconButton
                                aria-label="menu"
                                size="medium"
                                sx={{ color: '#FFFEFE', display: 'none' }}
                                onClick={handleDrawerOpen}
                            >
                                <MoreVertIcon fontSize="inherit" />
                            </IconButton>
                        )}
                </Grid>
            </GridShift>
            <br />
            <MobileDrawer
                open={open}
                toggleClose={handleDrawerClose}
                toggleOpen={handleDrawerOpen}
            />
        </Grid>
    );
};

export default Title;
